import React, { ReactNode } from 'react'

import { MessageSent } from 'src/components/animations'

import * as S from './SuccessView.styles'

const SuccessView = ({
  icon = <MessageSent width={150} height={150} />,
  children,
  spaceUnderAnimation,
}: {
  icon?: ReactNode
  children?: ReactNode | ReactNode[]
  spaceUnderAnimation?: boolean
}) => {
  return (
    <S.Wrapper>
      <S.AnimationWrap spaceUnderAnimation={spaceUnderAnimation}>{icon}</S.AnimationWrap>

      {children}
    </S.Wrapper>
  )
}

export default SuccessView
